import BaseDialog from 'components/BaseDialog'
import React, { useCallback } from 'react'
import { createModal } from 'react-modal-promise'
import { InjectedModalProps } from 'utils-next/modals'
import { ExtendableStyles } from 'utils-next/types'

import { Button, Typography } from '@mui/material'

import { UserStatus } from '../../../../../entities-next/user'

export type DemoteUserDealsWarningProps = ExtendableStyles &
  InjectedModalProps<boolean> & {
    userStatus: UserStatus
  }

export function DemoteUserDealsWarning({ userStatus, isOpen, onResolve }: DemoteUserDealsWarningProps) {
  const handleCancel = useCallback(() => {
    onResolve(false)
  }, [onResolve])
  const handleConfirm = useCallback(() => {
    onResolve(true)
  }, [onResolve])

  return (
    <BaseDialog
      title="Watch out!"
      description={
        <Typography>
          Changing this corporate status to <strong>{userStatus}</strong> will demote unmatched and un-sent deals
          associated to this corporate!
        </Typography>
      }
      open={isOpen}
      onClose={handleCancel}
      actions={
        <Button variant="outlined" onClick={handleConfirm} color="secondary">
          I understand
        </Button>
      }
    />
  )
}

export const showDemoteUserDealsWarningModal = createModal<DemoteUserDealsWarningProps>(DemoteUserDealsWarning)
